<div class="w-full bg-white border-box radius-10" style="border-radius: 10px;" id="contact-information">
  <div class="p-20 flex content-between" style="border-bottom: solid 1px #F0F5FF;">
    <div class="flex gap-10 align-items-center mb-5">
      <img src="assets/square-icon.svg" alt="">
      <div>
        <p class="no-margin light-blue bold">Tour concerné</p>
        <p class="no-margin dark-gray text-sm">Toutes les informations de ce bloc sont obligatoires</p>
      </div>
    </div>
  </div>

  <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 20px;" class="p-20">
    <div>
      <p class="dark-blue no-margin bold mb-10">S'agit-il d'une élection partielle ? <span class="red">*</span></p>
      <div class="flex gap-20">
        <label class="flex align-items-center gap-10">
          <input type="radio" name="isPartial" [value]="true" [(ngModel)]="round.shortage" (ngModelChange)="onPartialChange()">
          <span>Oui</span>
        </label>
        <label class="flex align-items-center gap-10">
          <input type="radio" name="isPartial" [value]="false" [(ngModel)]="round.shortage"
            (ngModelChange)="onPartialChange()">
          <span>Non</span>
        </label>
      </div>
    </div>
  </div>


  <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 20px;" id="information-grid" class="p-20">

    <div>
      <p class="dark-blue no-margin">Tour concerné <span class="red">*</span></p>
      <div class="flex gap-20">
        <label class="flex align-items-center gap-10">
          <input type="radio" name="round" [value]="true" [(ngModel)]="round.firstRound"
            (ngModelChange)="onRoundChange()">
          <span>1er tour</span>
        </label>
        <label class="flex align-items-center gap-10">
          <input type="radio" name="round" [value]="false" [(ngModel)]="round.firstRound"
            (ngModelChange)="onRoundChange()">
          <span>2nd tour</span>
        </label>
      </div>
    </div>

  </div>
</div>